// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"483fb1e0","667":"83d950f4","977":"37271a38"}[chunkId] + ".chunk.js";
};